<template>
  <div 
    v-if="endTime"
    :key="endTime"
  >
    <v-tooltip
      v-if="smallModeBreakpoint && $vuetify.breakpoint[`${smallModeBreakpoint}AndDown`]"
      v-model="showTooltip"
      bottom
      :color="tooltipColor"
    >
      <template #activator="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          :dark="dark"
          :error="veryLowTime"
          :warning="lowTime"
          :ripple="false"
          @click.stop="showTooltip = !showTooltip"
        >
          <v-icon
            :key="endTime"
            :class="{'error--text': veryLowTime, 'warning--text': !veryLowTime && lowTime}"
          >
            {{ timeLeft ? 'mdi-lock-outline' : 'mdi-lock-open-outline' }}
          </v-icon>
        </v-btn>
      </template>
      <span :class="[{'black--text': lowTime || veryLowTime}, 'font-weight-bold']">
        {{ timeLeftDisplay }}
      </span>
    </v-tooltip>
    <v-tooltip
      v-else
      class="ma-0 pa-0"
      top
    >
      <template #activator="{ on }">
        <v-btn
          class="mr-0"
          :dark="dark"
          :error="veryLowTime"
          :warning="lowTime"
          rounded
          text
          :ripple="false"
        >
          <!-- v-tooltip:top="{ html: 'Time remaining to edit this item' }"  -->
          <v-icon
            :key="endTime"
            class="mr-2"
            :class="{'error--text': veryLowTime, 'warning--text': !veryLowTime && lowTime}"
            left
          >
            {{ timeLeft ? 'mdi-lock-outline' : 'mdi-lock-open-outline' }}
          </v-icon>
          {{ timeLeftDisplay }}
        </v-btn>
      </template>
      <span>Time remaining to edit this item</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'LockTimer',

  props: {
    dark: Boolean,
    endTime: Number,
    onTimeout: {
      type: Function,
      default () {
        return () => {}
      }
    },
    onAccept: {
      type: Function,
      default () {
        return () => {}
      }
    },
    renewCb: Function,
    skipPrompt: Boolean,
    smallModeBreakpoint: String, // Working Options: 'xs', 'sm', 'md', 'lg'
  },

  data: function () {
    return {
      timeLeftDisplay: '0:00',
      timeLeft: 0,
      lowTime: false,
      veryLowTime: false,
      expTime: 0,
      interval: null,

      showTooltip: false,
    }
  },

  computed: {
    tooltipColor () {
      if (this.veryLowTime) return 'error'
      else if (this.lowTime) return 'warning'
      else return 'primary'
    }
  },

  watch: {
    endTime (newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.startTimer()
      }
    }
  },

  mounted () {
    this.startTimer()
  },

  updated () {
    this.startTimer()
  },

  beforeDestroy: function () {
    clearInterval(this.interval)
  },

  methods: {
    updateTimeLeft () {
      var _this = this
      var clientTime = Math.floor(new Date().getTime() / 1000)
      var timeLeft = _this.expTime - clientTime
      if (timeLeft <= 0) {
        timeLeft = 0
      }
      this.timeLeft = timeLeft
      this.veryLowTime = timeLeft < 30
      this.lowTime = !this.veryLowTime && timeLeft < 60
      var min = Math.floor(timeLeft / 60)
      var sec = timeLeft - min * 60
      var timeLeftDisplay = min + ':' + ('00' + sec).slice(-2)
      if (_this.timeLeftDisplay !== timeLeftDisplay) {
        _this.timeLeftDisplay = timeLeftDisplay
      }
      if (timeLeft < 1) {
        clearInterval(_this.interval)
        const prompt = {
          modal: true,
          width: 320,
          title: 'Edit Lock Expired',
          titleIcon: 'mdi-lock-open-outline',
          titleIconColor: 'error',
          text: 'Sorry, your edit lock has expired.',
          cancelText: 'Discard Changes',
          cancelAction: _this.onAccept
        }
        if (_this.renewCb) {
          prompt.confirmText = 'Re-Lock'
          prompt.confirmAction = (dialog) => {
            _this.interval = false
            _this.renewCb(dialog)
            return true
          }
        } else {
          prompt.confirmAction = false
        }
        if (!this.skipPrompt) {
          _this.$vPrompt(prompt)
          prompt.isLoading = true
          _this.onTimeout(() => {
            prompt.isLoading = false
          })
        }
      }
    },
    startTimer () {
      const _this = this
      if (!_this.interval && Number.isInteger(_this.endTime)) {
        clearInterval(_this.interval)
        _this.expTime = _this.endTime + _this.$ftAPI().timeOffset // Adjust expiration time based on client time to server time offset
        _this.updateTimeLeft()
        _this.interval = setInterval(_this.updateTimeLeft, 100) // Update timer 10 times a second to reduce judder (counter moves faster/slower than a second periodically)
      }
    }
  }
}
</script>
